import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const BedIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    "clip-path": "url(#clip0_25586_68105)"
  }, __jsx("path", {
    d: "M17.7496 4.85791V10.228C17.6627 10.4635 17.6161 10.4952 17.3472 10.4996C16.9076 10.4996 16.4681 10.4996 16.0285 10.4996C15.7349 10.4744 15.6234 10.3665 15.6183 10.0756C15.6093 9.55567 15.6171 9.11269 15.6148 8.59278C15.6136 8.30512 15.6069 8.29783 15.2981 8.29783C11.1055 8.29746 6.91251 8.29746 2.71991 8.29783C2.41147 8.29783 2.40442 8.30548 2.40325 8.59278C2.40129 9.11269 2.40873 9.55567 2.39972 10.0756C2.39463 10.3658 2.28229 10.4744 1.98911 10.4992C1.53466 10.4992 1.08022 10.4992 0.625767 10.4992C0.358812 10.4784 0.264478 10.3924 0.249995 10.1532C0.247255 10.1109 0.249212 10.0686 0.249212 10.0264C0.249212 6.72389 0.249212 4.29425 0.249212 0.991424C0.249212 0.906839 0.244124 0.822254 0.271524 0.739492C0.31967 0.597666 0.42105 0.508341 0.581535 0.505789C1.0626 0.497768 1.54367 0.498497 2.02473 0.505424C2.20792 0.507976 2.34492 0.631573 2.38602 0.808399C2.40794 0.903922 2.40246 1.00127 2.40246 1.09788C2.40246 2.68859 2.40246 4.27967 2.40246 5.87038C2.40246 5.9247 2.40168 5.97939 2.40285 6.03372C2.40794 6.26414 2.42634 6.28419 2.66981 6.28492C3.23542 6.28747 3.80104 6.28565 4.36704 6.28565C5.24502 6.28565 6.1226 6.28638 7.00058 6.28528C7.25187 6.28528 7.26557 6.27252 7.26597 6.03882C7.26753 5.17984 7.26597 4.32087 7.26675 3.46226C7.26675 3.36564 7.26362 3.26829 7.2871 3.17314C7.33877 2.96277 7.50395 2.82823 7.73764 2.80672C7.82179 2.79907 7.90673 2.80162 7.99089 2.80162C10.4291 2.80162 12.8677 2.79615 15.3059 2.80417C16.3812 2.80782 17.1069 3.33647 17.5934 4.19253C17.712 4.40108 17.7089 4.63442 17.7496 4.859V4.85791Z",
    fill: color
  }), __jsx("path", {
    d: "M4.85498 2.06643C3.71514 2.06169 2.77062 2.93342 2.7671 3.99329C2.76358 5.0681 3.68187 5.94057 4.82171 5.94531C5.99326 5.95041 6.93856 5.08414 6.93699 4.00714C6.93543 2.94874 5.99365 2.0708 4.85537 2.06643H4.85498Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_25586_68105"
  }, __jsx("rect", {
    width: "17.5",
    height: "10",
    fill: "white",
    transform: "translate(0.25 0.5)"
  }))));
};
export default BedIcon;